import React from "react";

const socials = [
  {
    label: "Thingiverse",
    href: "https://www.thingiverse.com/thebinaryartisan/designs",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/channel/UCCHVf7HeGUcX6d94YPUFhfg",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/thebinaryartisan/",
  },
];

const Footer = () => {
  return (
    <footer className="border-t border-white/5">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 py-12 sm:flex-row sm:justify-between">
        <p className="text-xs font-light tracking-luxe uppercase text-stone">
          Binary&nbsp;Artisan
        </p>
        <div className="flex items-center gap-8">
          {socials.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[0.65rem] font-light tracking-[0.2em] uppercase text-stone transition-colors duration-300 hover:text-gold"
            >
              {label}
            </a>
          ))}
        </div>
        <p className="text-xs font-light text-stone/70">
          © {new Date().getFullYear()} Binary Artisan. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
